import React from 'react';

import globalsService from '../../../services/GlobalsService';
import { t } from '../../../services/i18nService';

import styles from './photo.scss';

class FaceCircle extends React.PureComponent {
    render() {
        const assetRoot = globalsService.getAssetRoot();
        let faceCirclePath = 'images/idverification/face-circle-pink.svg';

        if (assetRoot) {
            faceCirclePath = `${assetRoot}/${faceCirclePath}`;
        }

        return (
            <div className={styles.faceCircle}>
                <div className={styles.faceCirclePositioner}>
                    <img
                        src={faceCirclePath}
                        alt={t('idVerification.photo.faceCircleAltText')}
                        className={styles.faceCircleShape}
                    />
                </div>
            </div>
        );
    }
}

export default FaceCircle;
